import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, MatComponentsModule, StorageUtilityLib, StripHtmlPipe } from '@thehubz/client/core';
import { CanEditVacationPipe } from './pipes/can-edit-vacation.pipe';
import { GetTimeSlotsPipe } from './pipes/get-time-slots.pipe';
import { TotalDurationPipe } from './pipes/total-duration.pipe';
import { DayAvailabilitySelectorComponent } from './user-availability/day-availability-selector/day-availability-selector.component';
import { UserAvailabilityComponent } from './user-availability/user-availability.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { UserPersonalInformationComponent } from './user-personal-information/user-personal-information.component';
import { UserProfessionalInformationComponent } from './user-professional-information/user-professional-information.component';
import { UserProfileComponent } from './user-profile.component';
import { UserVacationDialogComponent } from './user-vacations/user-vacation-dialog/user-vacation-dialog.component';
import { UserVacationsComponent } from './user-vacations/user-vacations.component';

@NgModule({
  imports: [
    CommonModule,
    MatComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    UiKitModule,
    ClientCoreModule,
    StripHtmlPipe,
  ],
  declarations: [
    UserProfileComponent,
    UserAvatarComponent,
    UserPersonalInformationComponent,
    UserProfessionalInformationComponent,
    UserAvailabilityComponent,
    UserVacationsComponent,
    UserVacationDialogComponent,
    CanEditVacationPipe,
    DayAvailabilitySelectorComponent,
    TotalDurationPipe,
    GetTimeSlotsPipe,
  ],
  exports: [
    UserProfileComponent,
    UserAvatarComponent,
    UserPersonalInformationComponent,
    UserProfessionalInformationComponent,
    UserAvailabilityComponent,
    UserVacationsComponent,
    UserVacationDialogComponent,
  ],
  providers: [StorageUtilityLib],
})
export class ClientUserProfileModule {}
